import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { getSystemStorageKey, getUrlOrSessionStorageValue } from '@common/constants/StoragePrefix';

const ALLOWED_LIMITS = [10, 25, 50, 100];

/**
 * Custom hook for retrieving the `limit` value for pagination.
 *
 * @param {number} [defaultLimit=10] - Default value for the limit.
 * @returns {number} - The limit value, validated against the allowed limits.
 */
function useLimit(defaultLimit: number): number {
	const [searchParams] = useSearchParams();
	const location = useLocation();

	return useMemo(() => {
		const value = Number(
			getUrlOrSessionStorageValue(searchParams, location.pathname, 'limit', getSystemStorageKey),
		);
		return ALLOWED_LIMITS.includes(value) ? value : defaultLimit;
	}, [searchParams, location.pathname, defaultLimit]);
}

export default useLimit;
